import React from 'react'
import XLSX from 'xlsx'
import {Form, Field} from 'simple-react-form'
import MultipleFiles from 'App/components/fields/MultipleFiles'
import fileUpload from 'App/helpers/fields/fileUpload'
import Button from 'orionsoft-parts/lib/components/Button'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withOrganization from 'App/Decorators/withOrganization'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import styles from './styles.css'
import find from 'lodash/find'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'
import Instructions from './Instructions'
import MdReplyAll from 'react-icons/lib/md/reply-all'
import baseURL from '../../../Root/url'
import emailValidation from 'App/helpers/validations/emailValidation'

@withOrganization
@withMutation(gql`
  mutation generateImportedDocument(
    $name: String
    $file: FileInput
    $emails: String
    $names: String
    $feaEmails: String
    $feaNames: String
    $faceEmails: String
    $faceNames: String
    $bioNames: String
    $bioEmails: String
    $bioRuts: String
    $tags: String
    $organizationId: ID
  ) {
    generateImportedDocument(
      name: $name
      file: $file
      emails: $emails
      names: $names
      feaEmails: $feaEmails
      feaNames: $feaNames
      faceEmails: $faceEmails
      faceNames: $faceNames
      bioNames: $bioNames
      bioEmails: $bioEmails
      bioRuts: $bioRuts
      tags: $tags
      organizationId: $organizationId
    ) {
      _id
    }
  }
`)

@withMutation(gql`
  mutation getMassiveUploadModel($documentos: [String]) {
    getMassiveUploadModel( documentos: $documentos)
  }
`)

@withMessage
export default class MassiveUpload extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      failed: [],
      showing: false,
      gettingModel: false,
      firmasAUsar: 0,
      feasAUsar: 0,
      facialesAUsar: 0
    }
  }
  static propTypes = {
    showMessage: PropTypes.func,
    organization: PropTypes.object,
    generateImportedDocument: PropTypes.func,
    getMassiveUploadModel: PropTypes.func
  }

  @autobind
  async getModeloParaUpload(){
    let archivos = this.state.files;
    if(!archivos || archivos.length === 0){
      alert("Aún no sube los archivos que serán agregados");
      return;
    }
    let archivosParaUpload = [];
    for (let index = 0; index < archivos.length; index++) {
      const archivo = archivos[index];
      console.log("Archivo " + index, archivo);
      archivosParaUpload.push(archivo.name);
    }
    console.log("Archivos: ", archivosParaUpload ); 
    this.setState({gettingModel:true});
    window.location.href = `${baseURL}/templates/masiveupload/${archivosParaUpload}`
    console.log("Paso generar imported");
  }

  @autobind
  async load() {
    console.log("Subiendo archivos...");
    this.setState({loading: true, errorMessages: null})
    if (!this.state.files) {
      this.props.showMessage('Necesitas cargar los archivos')
      this.setState({loading: false})
      return
    }
    if (!this.state.data) {
      this.props.showMessage('Necesitas cargar el archivo excel')
      this.setState({loading: false})
      return
    }
    console.log("Voy a iterar por los archivos...", this.state.data);
    for (const doc of this.state.files) {
      try {
        console.log("Mirando archivo "+ doc.name.trim());
        console.log("archivo ", doc);
        let datosArchivo = this.state.data[doc.name.trim()];
        console.log("Cargando archivo "+ doc.name + ", data asociada: ", datosArchivo);

        console.log("faceEmails", datosArchivo.faceEmails);
        await this.props.generateImportedDocument(
          {
            name: datosArchivo.nombre,
            file: find(this.state.files, {name: doc.name}).file,
            emails: datosArchivo.emails,
            names: datosArchivo.names,
            feaEmails: datosArchivo.feaEmails,
            feaNames: datosArchivo.feaNames,
            faceEmails: datosArchivo.faceEmails,
            faceNames: datosArchivo.faceNames,
            bioNames: datosArchivo.bioNames,
            bioEmails: datosArchivo.bioEmails,
            bioRuts: datosArchivo.bioRuts,
            tags: datosArchivo.tags,
            organizationId: this.props.organization._id
          },
          {
            refetchQueries: [
              'myDocumentsToSign',
              'myFeaDocumentsToSign',
              'documentCount',
              'organizationDocCount',
              'packsSignaturesCount',
              'planSignaturesCount'
            ]
          }
        )
        console.log(doc.name + " subido");
        
        this.props.showMessage('Creado documento ' + datosArchivo.nombre + ' con archivo ' + doc.name);
      } catch (error) {
        console.log('Error:', error)
        const failed = this.state.failed
        failed.push(doc.name)
        this.setState({failed: failed})
      }
    }
    this.setState({loading: false, data: null, files: null})
    //this.setState({loading: false, excel: null, files: null}

    setTimeout(() => {
          this.props.router.push('/documents')
        }, 7000
    );

    if (this.state.failed && this.state.failed.length !== 0) {
      this.props.showMessage(`Proceso finalizado con ${this.state.failed.length} fallidos`)
    } else {
      this.props.showMessage('Proceso finalizado con éxito')
    }
  }

  @autobind
  uploadExcel(file) {
    var reader = new FileReader()
    let numeroFirmasAUsar = 0;
    let numeroFeasAUsar = 0;
    let numeroFacialesAUsar = 0;
    reader.onload = e => {
      var file = e.target.result
      var workbook = XLSX.read(file, {
        type: 'binary',
        cellDates: true
      })
      // Here is your object
      const data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {
        raw: true
      })
      console.log("data: ", data);
      let dataPorArchivo = [];
      for (let index = 0; index < data.length; index++) {
        const fila = data[index];

        let nombres = fila.NombresFirmantes ? fila.NombresFirmantes: "";
        let nombreDocumento = fila.Nombre;
        if(!nombreDocumento){
          nombreDocumento = fila.Archivo;
        }
        if( !fila.EmailsFirmantes && !fila.EmailsBioFirma && !fila.EmailsFeas && !fila.EmailsFaciales ){
          this.props.showMessage(fila.Archivo + " no tiene firmantes");
          this.setState({data: null})
          return;
        }
        if(fila.EmailsFirmantes){
          let emails = fila.EmailsFirmantes.split(',');
          for (let k = 0; k < emails.length; k++) {
            const email = emails[k].trim();
            if(!emailValidation(email)){
              this.props.showMessage( email + " no es un email válido");
              this.setState({data: null})
              return;
            } 
            numeroFirmasAUsar++;
          }
        } 
        
        let feaEmails=null;
        if(fila.EmailsFeas){
          feaEmails = fila.EmailsFeas.split(',');
          for (let k = 0; k < feaEmails.length; k++) {
            const email = feaEmails[k].trim();
            if(!emailValidation(email)){
              this.props.showMessage( email + " no es un email válido");
              this.setState({data: null})
              return;
            } 
            numeroFeasAUsar++;
          }

          let feaNames = fila.NombresFeas.split(',');
          console.log("feas:" , feaEmails);
          console.log("feasNames:" , feaNames);
        }
        let bioEmails;
        if(fila.EmailsBioFirma){
          bioEmails = fila.EmailsBioFirma.split(',');
          for (let k = 0; k < bioEmails.length; k++) {
            const email = bioEmails[k].trim();
            if(!emailValidation(email)){
              this.props.showMessage( email + " no es un email válido");
              this.setState({data: null})
              return;
            } 
            //numeroFeasAUsar++;
          }

          let bioNames = fila.NombresBioFirma.split(',');
          let bioRuts = fila.RutsBioFirma.split(',');
          console.log("bios:" , bioEmails);
          console.log("bioNames:" , bioNames);
          console.log("bioRuts:" , bioRuts);
        }

        let faceEmails=null;
        if(fila.EmailsFaciales){
          faceEmails = fila.EmailsFaciales.split(',');
          for (let k = 0; k < faceEmails.length; k++) {
            const email = faceEmails[k].trim();
            if(!emailValidation(email)){
              this.props.showMessage( email + " no es un email válido");
              this.setState({data: null})
              return;
            } 
            numeroFacialesAUsar++;
          }

          let faceNames = fila.NombresFaciales.split(',');
          console.log("facialesEmails:" , faceEmails);
          console.log("faceNames:" , faceNames);
        }
        
        

        dataPorArchivo[fila.Archivo.trim()] = { 
          nombre: nombreDocumento,
          emails: fila.EmailsFirmantes, 
          names: fila.NombresFirmantes,
          feaEmails: fila.EmailsFeas,
          feaNames: fila.NombresFeas,
          faceEmails: fila.EmailsFaciales,
          faceNames: fila.NombresFaciales,
          bioEmails: fila.EmailsBioFirma,
          bioNames: fila.NombresBioFirma,
          bioRuts: fila.RutsBioFirma,
          tags: fila.Tags
        };
      }
      console.log("this.data: ", dataPorArchivo);
      this.props.showMessage("Excel validado correctamente");
      this.setState({data: dataPorArchivo, firmasAUsar: numeroFirmasAUsar, feasAUsar: numeroFeasAUsar, facialesAUsar: numeroFacialesAUsar })
    }
    reader.onerror = ex => {
      this.props.showMessage(ex)
    }
    reader.readAsBinaryString(file.file)
    this.setState({excel: {url: `/${file.file.name}`}})
  }

  renderFirmasAGastar(){
      //y {this.state.facialesAUsar} firmas faciales.
      if(this.state.firmasAUsar)
        return (
            <Tooltip content="">
              <div className="label">Se usarán {this.state.firmasAUsar} firmas simples, {this.state.feasAUsar} firmas avanzadas.
                  
              </div>
            </Tooltip>
        )
  }

  renderFailed() {
    if (!this.state.failed || this.state.failed.length === 0) {
      return
    }
    return (
      <div className={styles.fails}>
        Hubo errores en los siguientes documentos:
        {this.state.failed.map((fail, index) => <p key={index}>{fail}</p>)}
      </div>
    )
  }

  @autobind
  deleteExcel() {
    console.log('deleted')
    this.setState({data: null})
  }

  render() {
    const {showing} = this.state
    return (
      <div className="section">
        <div className="header">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8">
              <div className="row">
                <div className="col-xs-2 col-sm-">
                  <div className={styles.Icon}>
                    <MdReplyAll size={30} />
                  </div>
                </div>
                <div className="col-xs-10 col-sm-">
                  <div className={styles.Title2}>
                    <h3>Importación masiva de Documentos</h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xs-12 center-xs col-sm-12 center-sm col-md-4 end-md col-lg-4">
              <div className={styles.button}>
                <Button
                  onClick={() => this.setState({showing: !showing})}
                  style={{height: 30, fontSize: 14}}
                >
                  {showing ? <div>Volver</div> : <div>Instrucciones</div>}
                </Button>
              </div>

            </div>
          </div>
        </div>
        {showing ? (
          <div className="content" style={{padding: 0}}>
            <Instructions />
          </div>
        ) : (
          <div className="content">
            <div>
              <Form state={this.state} onChange={changes => this.setState(changes)}>
                <Tooltip content="Documents to send">
                  <div className="label">Documentos</div>
                </Tooltip>
                <Field fieldName="files" {...fileUpload} type={MultipleFiles} />
                <br />
                <div className="row">
                  <div className="col-xs-12 center-xs col-sm-6 start-sm">
                    <div className={styles.view}>
                      <Button primary onClick={this.getModeloParaUpload}>
                        Descargar Modelo
                      </Button>
                    </div>
                  </div>
                </div>
                <br />
                <Tooltip content="Excel file with 2 columns: email, name (where name is filename)">
                  <div className="label">Excel</div>
                </Tooltip>
                <Field
                  fieldName="excel"
                  {...fileUpload}
                  upload={this.uploadExcel}
                  delete={this.deleteExcel}
                />
                <br />
                {this.renderFirmasAGastar()}
                <br />
                <div className="row">
                  <div className="col-xs-12 center-xs col-sm-6 end-sm">
                    <div className={styles.view}>
                      <Button
                        primary
                        onClick={this.load}
                        loading={this.state.loading}
                        disabled={!this.state.files || !this.state.data}>
                        Cargar Documentos
                      </Button>
                    </div>
                  </div>
                </div>
              </Form>
              {this.renderFailed()}
            </div>
          </div>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/App/Pages/Documents/MassiveUpload/index.js